import React from 'react'
import './styles.scss'

export function BookingComponent() {
  return (
    <div id="booking-component" className="container">
      <div className="booking-header">
        <h3>MGI Mario Méndez Gestión Inmobiliaria</h3>
        <p>
          Registre su visita. Complete los datos requeridos e indique el día y horario que le quede
          bien visitar dicha propiedad.
        </p>
      </div>
      <form className="booking-form">
        <div className="form-group">
          <label htmlFor="name">Nombre y Apellido *</label>
          <input type="text" id="name" required />
        </div>
        <div className="form-group">
          <label htmlFor="id">C.I. *</label>
          <input type="text" id="id" required />
        </div>
        <div className="form-group">
          <label htmlFor="birthdate">Fecha de nacimiento *</label>
          <input type="date" id="birthdate" required />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Celular *</label>
          <input type="tel" id="phone" required />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input type="email" id="email" required />
        </div>
        <div className="form-group">
          <label htmlFor="address">Dirección personal *</label>
          <input type="text" id="address" required />
        </div>
        <div className="form-group">
          <label htmlFor="property">Propiedad a visitar *</label>
          <input type="text" id="property" required />
        </div>
        <div className="form-group">
          <label htmlFor="property">Operación *</label>
          <select
            className="form-control"
            // value={contact.operation}
            // onChange={(e) => handleFieldChange('operation', e.target.value)}
          >
            <option value="Quiero alquilar">Quiero alquilar</option>
            <option value="Quiero comprar">Quiero comprar</option>
            <option value="Quiero vender">Quiero vender</option>
          </select>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <label htmlFor="date">Fecha *</label>
          <input type="date" id="date" required />
        </div>
        <div className="form-group">
          <label htmlFor="time">Hora *</label>
          <input type="time" id="time" required />
        </div>
        <button type="submit" className="submit-button">
          ENVIAR
        </button>
      </form>
    </div>
  )
}
